<div class="row border-bottom mt-2">
  <div class="px-2 py-2 position-relative" style="background: #0c4788;">
    <!-- PLUS ICON (Top Right on Mobile Only) -->
    <div
      class="d-block d-md-none position-absolute top-0 end-0 mt-2 me-2"
      style="z-index: 10;"
    >
      <span
        *ngIf="heading === 'Admin: Course Management: MockExam : List' || heading === 'Admin: Study Unit: Practice Test : List'"
        [title]="heading === 'Admin: Course Management: MockExam : List' ? 'Add Mock Exam' : 'Add Study Unit Practice Test'"
        (click)="performAction()"
        class="cursor-pointer"
      >
        <i class="fa fa-plus-circle plus-icon fs-2 text-white"></i>
      </span>
    </div>

    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <!-- LEFT SIDE: Details & Button -->
      <div class="d-flex flex-wrap align-items-baseline gap-2 gap-md-4 flex-grow-1">
        <h6 class="mb-1 mb-md-0 px-1 text-white" *ngIf="heading">
          <strong>{{ heading }}</strong>
        </h6>
        <h6 class="mb-1 mb-md-0 px-1 text-white" *ngIf="ExamAgencyName">
          <strong>Exam Agency Name :</strong> <span class="fw-normal"> {{ ExamAgencyName }}</span>
        </h6>
        <h6 class="mb-1 mb-md-0 px-1 text-white" *ngIf="CourseName">
          <strong>Course Name :</strong> <span class="fw-normal"> {{ CourseName }}</span>
        </h6>
        <h6 class="mb-1 mb-md-0 px-1 text-white" *ngIf="ExamYear">
          <strong>Year :</strong> <span class="fw-normal"> {{ ExamYear }}</span>
        </h6>

        <!-- CLEAR BUTTON -->
        <button
        type="button"
        *ngIf="heading !== 'Admin: Course Management: MockExam : List' && heading !== 'Admin: Study Unit: Practice Test : List' && showChangeCourse && ExamYear"
        class="btn btn-sm border border-white text-white ms-1 ms-md-3 mt-2 mt-md-0"
        style="background: transparent;"
        (click)="clearSelectedCourse()"
      >
        Clear
      </button>


        <!-- CHANGE COURSE BUTTON -->
<button
  type="button"
  *ngIf="showChangeCourse"
  class="btn btn-sm ms-1 ms-md-1 mt-2 mt-md-0"
  style="background: #fff; color: #0c4788; border: 1px solid #0c4788;"
  (click)="open()"
>
  {{ExamYear ? 'Change Course' : 'Select Course'}}
</button>

      </div>

      <!-- PLUS ICON (Inline on Desktop Only) -->
      <div class="d-none d-md-flex align-items-center  flex-shrink-0 ms-md-3" style="min-width: 48px;">
        <span
          *ngIf="heading === 'Admin: Course Management: MockExam : List' || heading === 'Admin: Study Unit: Practice Test : List' || heading === 'Admin: Course Management: Practice Test : List'"
          [title]="heading === 'Admin: Course Management: MockExam : List' ? 'Add Mock Exam' : heading === 'Admin: Study Unit: Practice Test : List' ? 'Add Study Unit Practice Test' : 'Add Practice Test'"
          (click)="performAction()"
          class="cursor-pointer"
          style="line-height: 1;"
        >
          <i class="fa fa-plus-circle plus-icon fs-2 text-white"></i>
        </span>
      </div>
    </div>
  </div>
</div>
